


































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { FHIRListValue } from '@/store/modules/fhir/types/fhir.types';

@Component
export default class EditParameterConfigurationModal extends Vue {
  @Prop({ type: String, default: '' })
  public paramType!: string;

  @Prop({ type: String, default: 'all_clients' })
  public currentAccess!: string;

  @Prop({ type: Number, default: 0 })
  public defaultCardinality!: number;

  @Prop({ type: Number, default: 0 })
  public maxCardinality!: number;

  @Prop({ type: Array, default: () => [] })
  public listValues!: FHIRListValue[];

  public selectedAccess = '';
  public selectedDefaultCardinality = 0;
  public selectedMaxCardinality = 0;
  public localListValues: Array<{
    id: number;
    optionLabel: string;
    accessChosen: string;
  }> = [];

  public created() {
    this.selectedAccess = this.currentAccess;
    this.selectedDefaultCardinality = this.defaultCardinality;
    this.selectedMaxCardinality = this.maxCardinality;
    this.localListValues = this.listValues.map((lv) => ({ ...lv }));
  }

  get cardinalityError(): string | null {
    if (!this.hasCardinality) return null;
    if (
      this.selectedDefaultCardinality < 0 ||
      this.selectedMaxCardinality < 0
    ) {
      return 'Cardinality values must be 0 or greater.';
    }
    if (this.selectedDefaultCardinality > this.selectedMaxCardinality) {
      return 'Default cardinality cannot exceed maximum cardinality.';
    }
    return null;
  }

  public onCardinalityKeydown(e: KeyboardEvent) {
    const allowed = [
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'ArrowUp',
      'ArrowDown',
      'Tab',
      'Home',
      'End'
    ];
    if (allowed.includes(e.key)) return;
    if (!/^\d$/.test(e.key)) e.preventDefault();
  }

  get isListType(): boolean {
    return this.paramType === 'checklist' || this.paramType === 'radioList';
  }

  get hasCardinality(): boolean {
    return this.maxCardinality > 0;
  }

  public handleSave() {
    if (this.isListType) {
      this.$emit('save', {
        type: 'list',
        listValues: this.localListValues.map((lv) => ({
          id: lv.id,
          accessChosen: lv.accessChosen
        }))
      });
    } else {
      this.$emit('save', {
        type: 'standard',
        defaultCardinality: this.selectedDefaultCardinality,
        maxCardinality: this.selectedMaxCardinality,
        accessChosen: this.selectedAccess
      });
    }
    this.$emit('close');
  }
}
